"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.index-of.js");

var TYPE_CLASSES_MAP = {
  normal: 'sk-icon-success',
  success: 'sk-icon-success',
  alarm: 'sk-icon-warning',
  error: 'sk-icon-error',
  ing: 'el-icon-loading',
  stop: 'sk-icon-sleep',
  offline: 'sk-icon-error'
};
var _default = {
  name: 'SkIconStatus',
  props: {
    type: {
      type: String,
      "default": 'info'
    },
    content: {
      type: String,
      "default": ''
    },
    label: {
      type: String,
      "default": ''
    },
    isColorfulContent: {
      type: Boolean,
      "default": true
    },
    icon: {
      type: String,
      "default": ''
    },
    dangerouslyUseHTMLString: {
      type: Boolean,
      "default": false
    },
    simple: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    typeClass: function typeClass() {
      return "sk-icon-status--".concat(this.type);
    },
    iconClass: function iconClass() {
      if (this.icon === '') {
        return [TYPE_CLASSES_MAP[this.type] || 'el-icon-info', "sk-icon-status__icon--".concat(this.type)];
      }

      return [this.icon, "sk-icon-status__icon--".concat(this.type)];
    },
    contentClass: function contentClass() {
      if (this.isColorfulContent) {
        return ["sk-icon-status__content--".concat(this.type), {
          'sk-italic-font': this.type.indexOf('ing') >= 0
        }];
      }

      return [];
    }
  },
  render: function render(h) {
    var _vm = this;

    var iconClass = this.iconClass,
        typeClass = this.typeClass,
        content = this.content,
        contentClass = this.contentClass,
        dangerouslyUseHTMLString = this.dangerouslyUseHTMLString,
        simple = this.simple,
        type = this.type,
        label = this.label;
    var vnode;
    vnode = !simple ? h("span", {
      "class": [typeClass]
    }, [h("i", {
      "class": [iconClass]
    }), h("slot", [dangerouslyUseHTMLString ? h("span", {
      "class": ['sk-icon-status__content', contentClass],
      "directives": [{
        name: "html",
        value: content
      }]
    }) : h("span", {
      "class": ['sk-icon-status__content', contentClass]
    }, [content])])]) : h("span", [h("span", {
      "class": ['sk-rs-status', 'sk-rs-status--' + type]
    }), h("span", {
      "class": ['sk-rs-status__label', 'sk-rs-status__' + type + '-label']
    }, [label || content])]);
    return vnode;
  }
};
exports["default"] = _default;